import { useState } from 'react';
import { SearchableSelect } from '../common/SearchableSelect';
import { EntityModal } from '../common/EntityModal';

interface EventSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (eventId: string) => void;
  title?: string;
}

export function EventSelectorModal({
  isOpen,
  onClose,
  onSelect,
  title = 'Select Event',
}: EventSelectorModalProps) {
  const [selectedEventId, setSelectedEventId] = useState<string>('');

  const handleConfirm = () => {
    if (selectedEventId) {
      onSelect(selectedEventId);
      setSelectedEventId('');
    }
  };

  const handleClose = () => {
    setSelectedEventId('');
    onClose();
  };

  return (
    <EntityModal
      open={isOpen}
      onClose={handleClose}
      title={title}
      size="sm"
      presentation="centered"
      footer={
        <>
          <button
            type="button"
            onClick={handleClose}
            className="min-h-11 px-4 py-2 border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={!selectedEventId}
            className="min-h-11 px-4 py-2 bg-primary-600 text-white text-sm rounded-md hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Continue
          </button>
        </>
      }
    >
      <span className="block text-sm font-medium text-gray-700 mb-2">Event</span>
      <SearchableSelect
        entityType="event"
        value={selectedEventId}
        onChange={(v) => setSelectedEventId(typeof v === 'string' ? v : '')}
        placeholder="Search events..."
      />
    </EntityModal>
  );
}
